import {useContext} from 'react';

import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';

import {Box, Grid, Typography} from '@mui/material';

import {EmpionButton} from '../../../../components/EmpionButton/EmpionButton';
import {SnackBarContext} from '../../../../contexts/SnackBarContext/SnackBarContext';
import {orangeColors} from '../../../../layouts/theme/designSystem';
import {AppConfig} from '../../../../lib/AppConfig';
import {copyTextToClipBoard} from '../../../../utils/copyTextToClipboard/copyTextToClipBoard';

interface Props {
  surveyId: string;
}

export const InvalidTalentSurveyMessage = ({surveyId}: Props) => {
  const {dispatchMessage} = useContext(SnackBarContext);
  const {t} = useTranslation();

  const copyTalentSurveyId = async (id: string) => {
    try {
      await copyTextToClipBoard(id);
      dispatchMessage(t('shared.copied'), 'success');
    } catch (e: any) {
      dispatchMessage(t('shared.copyError'), 'error');
    }
  };

  return (
    <Grid container mt={20} flexDirection={'column'} alignItems={'center'} textAlign={{xs: 'center', sm: 'left'}}>
      <Grid item>
        <Typography variant='h1' textAlign={'center'} gutterBottom>
          {t('registration.signUp.page.invalidSurvey')}
        </Typography>
        <Box display={'flex'} justifyContent={'center'}>
          <Typography
            fontWeight={'bold'}
            sx={{
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              cursor: 'pointer',
              backgroundColor: orangeColors[4],
              width: 'fit-content',
              padding: '0.5rem 1rem',
              borderRadius: '0.5rem',
            }}
            onClick={() => copyTalentSurveyId(surveyId)}
          >
            {surveyId}
          </Typography>
        </Box>
      </Grid>
      <Grid item marginTop={4}>
        <Link to={AppConfig.HOME_PATH} style={{textDecoration: 'none'}}>
          <EmpionButton>
            <Typography variant='h4' color={'white'}>
              {t('registration.signUp.page.CTA')}
            </Typography>
          </EmpionButton>
        </Link>
      </Grid>
    </Grid>
  );
};
